import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

export function Tooltip({ children, dismissLabel = null, handleClick, styleObj }) {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	return (
		<Box
			sx={{
				width: '320px',
				height: '48px',
				borderRadius: '8px',
				padding: '15px',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				position: 'fixed',
				margin: 0,
				background: theme.palette.common.black,
				color: theme.palette.root.basicWhite,
				...styleObj,
			}}
		>
			{children}
			<Typography sx={{ cursor: 'pointer' }} onClick={handleClick}>
				{dismissLabel || 'Dismiss'}
			</Typography>
		</Box>
	);
}
